import React from 'react'
import { useDispatch } from 'react-redux'
import { setDrawer } from 'slices/drawer'
import { STATICS } from 'statics'
import { DRAWER_KEY } from 'app-constants'
import { BaseCard } from '../base-card'

export function DigitalServicesCard() {
  const dispatch = useDispatch()

  function handleClick() {
    dispatch(setDrawer(DRAWER_KEY.SERVICES))
  }

  return <BaseCard onClick={handleClick} text='Serviços digitais' icon={<STATICS.MY_SERVICES />} />
}
